import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cb.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/mastercard.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/visa.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/paypal.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/4_credit_card.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/installments.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_fr.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_de.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_en.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_es.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_it.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_nl.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_transfer_pt.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bank_check.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/ideal.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/sofort.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bcmc.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/sequra.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/maestro.svg';
export default {
  name: 'Payment',
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: {
    setLanguage: function setLanguage(link) {
      if (link === 'bank_transfer') {
        return "_".concat(this.locale.language);
      }

      return '';
    }
  }
};